<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Daily Expenses</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="date"
                  label="From"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker @change="getExpenses" v-model="date" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12" class="subtitle-2 text--primary">
            <span v-if="TotalExpenses">Total: {{TotalExpenses.toLocaleString()}}</span>
            <!-- start of table -->
            <v-data-table
              :mobile-breakpoint="0"
              :headers="headers"
              :items="expenses"
              :search="search"
            ></v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    date: new Date().toISOString().substr(0, 10),
    menu1: false,
    headers: [
      { text: "Category", value: "vpm1.Name" },
      { text: "Amount", value: "Amount" },
      { text: "Account", value: "account.Name" },
      { text: "Description", value: "Description" },
      { text: "Date", value: "DocDate" },
    ],
    expenses: [],
    TotalExpenses: null,
  }),
  methods: {
    setDate(date) {
      this.date = date;
    },
    getExpenses() {
      const data = {};
      data.StartDate = this.date;
      const url = "/expense-report";
      const self = this;
      this.$store.commit('loader', true);
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.expenses = res.ResponseData.AllExpenses;
            self.TotalExpenses = res.ResponseData.TotalAmount;
            self.$store.commit('loader', false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getExpenses();
  },
};
</script>